<script setup>
    import { useButtonStyles, buttonStyleProps } from '@Common/Composables/button-styles';
    import { ref } from 'vue';
    import Spinner from '@Common/Icons/Spinner.vue';

    const props = defineProps({
        trackEvent: {type: String, default: ''},
        disabled: {type: Boolean, default: false},
        loading: {type: Boolean, default: false},
        inputType: {type: String, default: 'button'},
        ...buttonStyleProps
    });

    const emit = defineEmits(['click']);

    const { typeClasses, sizeClass } = useButtonStyles(ref(props.type), ref(props.size));

    function onSubmit() {
        if (!props.loading && !props.disabled) {
            emit('click');
        }
    }
</script>
<template>
    <button :type="inputType" :class="[typeClasses, sizeClass]" @click="onSubmit" @submit="onSubmit" :disabled="disabled || loading">
        <transition name="spinner">
            <Spinner v-if="loading"/>
        </transition>
        <slot/>
    </button>
</template>
<style lang="scss">
@import 'buttons';

.spinner-enter-active, .spinner-leave-active {
    transition: opacity .3s ease, transform .3s ease;
}

.spinner-enter-from {
    opacity: 0;
    transform: translateY(-50%);
}

.spinner-leave-to {
    opacity: 0;
    transform: translateY(50%);
}
</style>